/* Instant Price Match — storefront widget.
   Talks to the app through Shopify's App Proxy (/apps/price-match), so the
   customer identity is signed by Shopify and can't be spoofed. */
(function () {
  var ENDPOINT = '/apps/price-match';

  function money(n) {
    return '£' + Number(n).toFixed(2);
  }

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  function comparisonTable(c) {
    if (!c) return null;
    var wrap = el('div', 'pm__compare');
    var rows = [
      ['Our price', money(c.ourPriceExVat) + ' ex VAT', money(c.ourPriceIncVat) + ' inc VAT'],
      [
        c.theirSite || 'Their price',
        money(c.theirPriceExVat) + ' ex VAT',
        c.theirPriceIncVat != null ? money(c.theirPriceIncVat) + ' inc VAT' : '—'
      ]
    ];
    if (c.theirDeliveryExVat != null) {
      rows.push([
        'Their delivery',
        c.theirDeliveryExVat > 0 ? money(c.theirDeliveryExVat) + ' ex VAT' : 'Free',
        ''
      ]);
    }
    rows.forEach(function (r) {
      var row = el('div', 'pm__compare-row');
      row.appendChild(el('span', 'pm__compare-label', r[0]));
      row.appendChild(el('span', 'pm__compare-a', r[1]));
      row.appendChild(el('span', 'pm__compare-b', r[2]));
      wrap.appendChild(row);
    });
    return wrap;
  }

  function render(box, data) {
    box.innerHTML = '';
    box.hidden = false;

    var decision = data.decision || 'review';
    box.className = 'pm__result pm__result--' + decision;

    box.appendChild(el('p', 'pm__message', data.message || 'Thanks — we’re on it.'));

    var table = comparisonTable(data.comparison);
    if (table) box.appendChild(table);

    if (data.applyUrl && data.matchedPriceIncVat != null) {
      var cta = el('a', 'pm__apply');
      cta.href = data.applyUrl;
      cta.textContent = 'Apply ' + money(data.discountIncVat) + ' off — new price ' +
        money(data.matchedPriceIncVat);
      box.appendChild(cta);
      var small = el(
        'p',
        'pm__fineprint',
        'Reserved for your account on this item only. Code ' + data.discountCode +
          ', valid 48 hours.'
      );
      box.appendChild(small);
    }
  }

  function wire(root) {
    if (root.dataset.pmReady) return;
    root.dataset.pmReady = '1';

    var toggle = root.querySelector('[data-pm-toggle]');
    var form = root.querySelector('[data-pm-form]');
    var result = root.querySelector('[data-pm-result]');
    var submit = root.querySelector('[data-pm-submit]');
    if (!toggle || !form || !result || !submit) return;

    toggle.addEventListener('click', function () {
      form.hidden = !form.hidden;
      if (!form.hidden) {
        var input = form.querySelector('input');
        if (input) input.focus();
      }
    });

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var input = form.querySelector('input');
      var url = (input && input.value || '').trim();
      if (!url) return;

      submit.disabled = true;
      var original = submit.textContent;
      submit.textContent = 'Checking…';
      result.hidden = false;
      result.className = 'pm__result pm__result--pending';
      result.textContent = 'Checking their price, delivery and stock…';

      fetch(ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          variantId: root.dataset.variant,
          competitorUrl: url
        })
      })
        .then(function (response) {
          return response.json().catch(function () {
            return { decision: 'review', message: 'Something went wrong — the team will pick this up.' };
          });
        })
        .then(function (data) {
          render(result, data);
        })
        .catch(function () {
          render(result, {
            decision: 'review',
            message: 'We couldn’t reach the checker just now. Please try again in a moment.'
          });
        })
        .then(function () {
          submit.disabled = false;
          submit.textContent = original;
        });
    });
  }

  /* Visibility is decided by the app, not by Liquid.
     Under Shopify's new customer accounts (and B2B company logins) the theme
     can't reliably see `customer`, so the widget ships hidden and we ask the
     app — through the signed App Proxy — whether this shopper qualifies. */
  var eligibility = null;
  function reveal() {
    document.querySelectorAll('[data-pm][data-pm-gated]').forEach(function (el) {
      el.hidden = false;
      el.removeAttribute('data-pm-gated');
      wire(el);
    });
  }
  function askEligibility() {
    var gated = document.querySelectorAll('[data-pm][data-pm-gated]');
    if (!gated.length) return;
    if (eligibility === true) return reveal();
    if (eligibility === false) return;
    fetch(ENDPOINT + '/eligible', {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        eligibility = !!(d && d.eligible);
        if (eligibility) reveal();
      })
      .catch(function () { /* stay hidden on any failure */ });
  }

  function init() {
    document.querySelectorAll('[data-pm]:not([data-pm-gated])').forEach(wire);
    askEligibility();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Warehouse re-renders the cart via AJAX; re-wire whatever appears.
  document.documentElement.addEventListener('cart:refresh', function () {
    setTimeout(init, 60);
  });
  document.documentElement.addEventListener('product:added', function () {
    setTimeout(init, 60);
  });
})();
